<div class="pb-5 px-md-5 mt-md-5">
  <h2 class="text-info mb-4">Autour de vous, les associations suivantes peuvent vous accompagner :</h2>
  <div class="row g-4">
    <div class="col-12 col-lg-6" *ngFor="let association of associations">
      <div class="card-resource">
        <img [src]="association.image | companyImage" class="association-logo" [alt]="association.name" *ngIf="association.image">
        <h3 class="card-resource-title">{{association.name}}</h3>
        <p class="card-resource-text">{{association.summary}}</p>
        <ul class="card-resource-info">
          <li *ngIf="association.website">
            <span class="material-icons">language</span>
            <a href="{{association.website}}" target="_blank">{{association.website}}</a>
          </li>
          <li *ngIf="association.schedule">
            <span class="material-icons">schedule</span>
            <span>{{association.schedule}}</span>
          </li>
          <li *ngIf="association.phone">
            <span class="material-icons">phone</span>
            <span>{{association.phone}}</span>
          </li>
          <li *ngIf="association.address">
            <span class="material-icons">location_on</span>
            <span>{{association.address}} {{association.zipCode}} {{association.city}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
